export default __webpack_public_path__ + "static/media/FindClassroomImage.7ef6ca7b.svg";